"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeStyles = exports.CardTitleAndBodyContainer = exports.CardTitle = exports.CardContentContainer = exports.CardContainer = exports.CardBody = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var sizeStyles = exports.sizeStyles = {
  sm: {
    title: 'title16',
    body: 'body14',
    padding: '16px',
    titleAndBodyGap: '4px'
  },
  md: {
    title: 'title18',
    body: 'body16',
    padding: '24px',
    titleAndBodyGap: '6px'
  },
  lg: {
    title: 'display24',
    body: 'body18',
    padding: '32px',
    titleAndBodyGap: '8px'
  }
};
var layoutStyles = {
  "default": (0, _styledComponents.css)(["flex-direction:column;"]),
  'side-by-side': (0, _styledComponents.css)(["flex-direction:row-reverse;justify-content:space-between;"])
};
function getCardContainerPadding(_ref) {
  var size = _ref.size;
  var padding = sizeStyles[size].padding;
  return (0, _styledComponents.css)(["padding:", ";"], padding);
}
var CardContentContainer = exports.CardContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutCardstyles__CardContentContainer",
  componentId: "sc-1seruj0-0"
})(["display:flex;flex-direction:column;justify-content:space-between;flex-shrink:1000000;", ""], function (props) {
  return getCardContainerPadding(props.theme);
});
var CardTitleAndBodyContainer = exports.CardTitleAndBodyContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutCardstyles__CardTitleAndBodyContainer",
  componentId: "sc-1seruj0-1"
})(["display:flex;flex-direction:column;gap:", ";"], function (props) {
  return sizeStyles[props.theme.size].titleAndBodyGap;
});
var CardContainer = exports.CardContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutCardstyles__CardContainer",
  componentId: "sc-1seruj0-2"
})(["position:relative;background-color:", ";overflow:hidden;border-radius:4px;box-shadow:0px 1px 3px 0px rgba(0,18,71,0.16);display:flex;", ""], _colors["default"].white, function (props) {
  return layoutStyles[props.theme.layout];
});
var CardTitle = exports.CardTitle = (0, _styledComponents["default"])(_HBText["default"]).attrs({
  color: 'textPrimary',
  tag: 'h2'
}).withConfig({
  displayName: "HBCalloutCardstyles__CardTitle",
  componentId: "sc-1seruj0-3"
})(["margin:0;"]);
var CardBody = exports.CardBody = (0, _styledComponents["default"])(_HBText["default"]).attrs({
  color: 'textPrimary',
  tag: 'div'
}).withConfig({
  displayName: "HBCalloutCardstyles__CardBody",
  componentId: "sc-1seruj0-4"
})([""]);
//# sourceMappingURL=HBCalloutCard.styles.js.map